import { ModelBase } from "../abstract/model-base.model";

/**
 * Assistant IA enregistré auprès de Biifor pour se brancher sur le connecteur IA
 * (#1312) : ChatGPT, Claude, Le Chat… `name` est celui sous lequel l'assistant s'est
 * présenté, « Assistant inconnu » quand il ne l'a pas fait.
 */
export class AssistantClient extends ModelBase {

    static override CLASS_NAME: string = 'AssistantClient';

    private _clientId!: string;
    private _name!: string;

    public get clientId(): string {
        return this._clientId;
    }

    public set clientId(value: any) {
        this._setValue('_clientId', value, 'string');
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: any) {
        this._setValue('_name', value, 'string');
    }

}
